/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import ImageLoader from 'react-render-image';
import LoadingSkeleton from '../loading-skeleton';
var ImageIcon = function ImageIcon(_ref) {
  var defaultIcon = _ref.defaultIcon,
    testId = _ref.testId,
    url = _ref.url,
    onError = _ref.onError,
    onLoad = _ref.onLoad;
  return jsx(ImageLoader, {
    src: url,
    loading: jsx(LoadingSkeleton, {
      testId: "".concat(testId, "-loading")
    }),
    loaded: jsx("img", {
      src: url,
      "data-testid": "".concat(testId, "-image")
    }),
    errored: defaultIcon,
    onError: onError,
    onLoad: onLoad
  });
};
export default ImageIcon;